import RegEx from './FormUtils/RegEx';

export const formatIndian = (value: number | string): string => {
  if (value === null) {
    return '-';
  } else if (isNaN(value as number)) {
    if (value === 'N/A') {
      return `${value}`;
    } else {
      return '-';
    }
  } else {
    const string = String(value);
    const stringArray = string.split('.');

    return (
      stringArray[0].replace(RegEx.sumValue, '$1,') +
      (stringArray[1] ? '.' + stringArray[1] : '')
    );
  }
};
